/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DemoAccountDataSummaryCto } from '../../models/demo-account-data-summary-cto';

export interface GetDemoAccountDataSummariesAsync$Plain$Params {
}

export function getDemoAccountDataSummariesAsync$Plain(http: HttpClient, rootUrl: string, params?: GetDemoAccountDataSummariesAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DemoAccountDataSummaryCto>>> {
  const rb = new RequestBuilder(rootUrl, getDemoAccountDataSummariesAsync$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DemoAccountDataSummaryCto>>;
    })
  );
}

getDemoAccountDataSummariesAsync$Plain.PATH = '/demo-account-data';
